import React from 'react';
import AppContext from "./AppContext"
import { Route, Switch, BrowserRouter } from "react-router-dom";
import { connect } from 'react-redux';
//#region MODULES
import Dashboard from './Dashboard';
import TaskManagement from './TaskManagement/TaskManagement';
import Logout from './Logout';
import T_Error from "./404"
// import IFrame from "./Schedule/iFrame"
//#endregion MODULES
import HeaderNav from './shared/header';
import { Layout, notification, message } from "antd";
import { pages, testpages } from "../Models/shared/master"
import { isMobile } from 'react-device-detect';
import Item from 'antd/lib/list/Item';
const { Content } = Layout;

const offlineNoti = () => {
    const data = new Date()
    notification.info({
        key: "offlinenoti",
        message: "Offline Notice",
        description:
            <>
                <p>
                    {data.toString()}
                </p>
                <b>
                    You've gone offline. Check your internet connection and wait till the internet is back working.
                </b>
                <br />
                <small>
                    Operations were largely limited as this site requires internet connection
                </small>
            </>,
        placement: "bottomRight",
        duration: 0
    })
}
class Index extends React.Component {
    componentDidMount() {
        message.config({
            maxCount: 2,
            duration: 2,
        })
        window.addEventListener("offline", () => {
            offlineNoti()
        })
        window.addEventListener("online", () => {
            notification.close("offlinenoti")
        })
    }
    render() {
        const global = {
            UserIdentity: this.props.UserIdentity
        }
       // console.log(global.UserIdentity)
        return (
            <>
                <Layout>
                    <AppContext.Provider value={global}>
                        <BrowserRouter key="br3">
                            <Layout>
                                <HeaderNav isMob={isMobile} UserIdentity={global.UserIdentity} />
                                <Layout
                                    style={{
                                        padding: '2px 2px 2px 2px',
                                        minHeight: "100vh"
                                    }}
                                >
                                    <Content
                                        style={{
                                            // padding: 24,
                                            margin: 0,
                                            minHeight: 280,
                                        }}
                                    >
                                        <Switch>
                                            {pages.map(page =>
                                                // global.UserIdentity.permission[0] === "Root" ?
                                                <Route key={page.title} path={page.path}
                                                >
                                                    {page.component}
                                                </Route>
                                            )}
                                            {
                                                testpages.map(page => 
                                                    <Route key={page.title} path={page.path}
                                                    >
                                                        {page.component}
                                                    </Route>
                                                )
                                            }
                                            {/* {pages.map(page =>
                                                global.UserIdentity.permission[0] === "Root" ?
                                                    <Route key={page.title} path={page.path}
                                                    >
                                                        {page.component}
                                                    </Route>
                                                    :
                                                    global.UserIdentity.permission.includes(page.key) ?
                                                        <Route key={page.title} path={page.path}
                                                        >
                                                            {page.component}
                                                        </Route>
                                                        :
                                                        null
                                            )} */}

                                            <Route key="Dashboard" path='/Dashboard'>
                                                <Dashboard title="Dashboard" />
                                            </Route>
                                            {/* <Route key="broadcastutils" path='/broadcastUtil' render={(props) => <IFrame {...props} />} /> */}
                                            <Route key="logout" path='/Logout'>
                                                <Logout />
                                            </Route>
                                            <Route key="dashboard" exact path="/">
                                                <TaskManagement />
                                            </Route>
                                            
                                            <Route key="error" sensitive path="/">
                                                <T_Error />
                                            </Route>
                                        </Switch>
                                    </Content>
                                </Layout>
                            </Layout>
                        </BrowserRouter>
                    </AppContext.Provider>
                </Layout>
            </>
        )
    }
}

const mapStateToProps = ({ login }) => ({
    UserIdentity: login
})
export default connect(mapStateToProps)(Index);



